import { createApi } from '@reduxjs/toolkit/query/react';
import {
  ArgsInitSliceMeta,
  ReferenceOfMeta,
  dynamicFetchBaseFactory,
} from '@vs/rtk/utils';
import { rtkCacheTTL } from '@vs/utils/constants';

const referenceOfMeta: ReferenceOfMeta = {
  _deployEnv: undefined,
  _baseUrl: undefined,
  _getTokenFunc: undefined,
  _assetsUrl: undefined,
};

export function initSliceMeta({
  deployEnv,
  getTokenFunc,
  baseUrl,
  env,
}: ArgsInitSliceMeta) {
  referenceOfMeta._deployEnv = deployEnv;
  referenceOfMeta._baseUrl = baseUrl;
  referenceOfMeta._getTokenFunc = getTokenFunc;
  referenceOfMeta._assetsUrl = env?.assets.vs;
}

export const apiMiscellaneousSlice = createApi({
  reducerPath: 'apiMiscellaneous',
  keepUnusedDataFor: rtkCacheTTL.normal,
  refetchOnMountOrArgChange: rtkCacheTTL.normal,
  baseQuery: dynamicFetchBaseFactory(referenceOfMeta, {
    credentials: 'omit',
  }),
  endpoints: build => ({
    getCountry: build.query<{ viewerCountry: string | null }, void>({
      queryFn: async () => {
        const timestamp = Date.now();
        const url = `${referenceOfMeta._assetsUrl}/country.png?t=${timestamp}`;
        const response = await fetch(url, { method: 'GET', mode: 'cors' });
        const viewerCountry = response.headers.get('Viewer-Country');
        return { data: { viewerCountry: viewerCountry } };
      },
      extraOptions: {
        isPublicEndpoint: true,
      },
    }),
    // This endpoint is used on local dev mode, mainly for subscription e2e test
    activateTrialManually: build.mutation<void, ArgsActivateTrialManually>({
      query: ({ subscription_id }) => ({
        url: `/subscription/api/v1/resource/activate-trial`,
        method: 'PUT',
        body: {
          subscription_id,
        },
        headers: {
          'test-token': 'ci-test-bypass-trial',
        },
      }),
    }),
  }),
});

type ArgsActivateTrialManually = {
  subscription_id: string;
};

export const { useGetCountryQuery, useActivateTrialManuallyMutation } =
  apiMiscellaneousSlice;
